export class ActiveOldUser{
    userName:string;
    password:string;
    phoneNumber:string;
}